(function ($, Drupal, once) {
  Drupal.behaviors.clinicImages = {
    attach: function (context, settings) {
      // Select all slider instances
      const sliders = once('clinic-images-init', '.clinic-card .google-photos-gallery .splide', context);
      sliders.forEach((sliderElement) => {
        const slideCount = sliderElement.querySelectorAll('.splide__slide').length;

        const splideSlider = new Splide(sliderElement, {
          type: 'fade',
          perPage: 1,
          pagination: slideCount > 1,
          drag: slideCount > 1,
          arrows: false
        });

        splideSlider.mount();
      });
    }
  };
})(jQuery, Drupal, once);
